// todo add more stuff from http://fbdevwiki.com/wiki/Open_Graph_protocol#Types

export const ogTypes = [
  'article',
  'book',
  'books.author',
  'books.book',
  'books.genre',
  'business.business',
  // 'fitness.course',
  // 'game.achievement',
  'music.album',
  'music.playlist',
  'music.radio_station',
  'music.song',
  'place',
  'product',
  'product.group',
  'product.item',
  'profile',
  'restaurant.menu',
  'restaurant.menu_item',
  'restaurant.menu_section',
  'restaurant.restaurant',
  'video.episode',
  'video.movie',
  'video.other',
  'video.tv_show',
];



// WEBPACK FOOTER //
// ./scripts/constants/ogtypes.js